import React, { FunctionComponent } from "react";
import { styled } from "@iventis/styles";
import { Theme } from "@emotion/react";
import { Tools, ToolBarComponent } from "./sidebar-tools";

interface SideBarProps {
    minimumWidth: string;
    startingWidth: number;
    tools: Tools;
    children?: React.ReactNode;
}

/**
 * Component which can be used as a sidebar
 * @param {string} minimumWidth - the smallest the sidebar can be (string so it can be percentages)
 * @param {number} startingWidth - the starting width of the sidebar
 * @param {Tools} tools - buttons to be shown at the bottom of the sidebar
 * @param children - content of the sidebar
 */
export const SideBarComponent: FunctionComponent<SideBarProps> = ({ minimumWidth, startingWidth, tools, children }) => (
    <SideBarContainer minimumWidth={minimumWidth} startingWidth={startingWidth}>
        <SideBarContent>{children}</SideBarContent>
        <FooterStyleBar>
            <ToolBarComponent tools={tools} />
        </FooterStyleBar>
    </SideBarContainer>
);

const SideBarContainer = styled.div<{ minimumWidth: string; startingWidth: number }>`
    display: flex;
    flex-direction: column;
    min-width: ${({ minimumWidth }) => minimumWidth};
    width: ${({ startingWidth }) => `${startingWidth}px`};
    height: 100%;
    border-right: ${({ theme }: { theme: Theme }) => `1px solid ${theme.shades.three}`};
`;

const SideBarContent = styled.div`
    padding: 10px;
    overflow-y: auto;
    display: flex;
    flex-grow: 1;
    flex-shrink: 1;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
`;

export const StyledBar = styled.div`
    padding: 10px;
    box-sizing: border-box;
    height: ${({ theme }: { theme: Theme }) => theme.sizes.iconButtonWidth};
    background-color: ${({ theme }: { theme: Theme }) => theme.secondaryColors.warm};
    display: flex;

    .left {
        flex-grow: 1;
    }

    button {
        height: 100%;
        width: ${({ theme }: { theme: Theme }) => theme.sizes.iconButtonWidth};
        color: ${({ theme }: { theme: Theme }) => theme.primaryColors.subdued70};
        :hover {
            color: ${({ theme }: { theme: Theme }) => theme.primaryColors.focusAccent};
        }
    }
`;

const FooterStyleBar = styled(StyledBar)`
    flex-grow: 0;
    flex-shrink: 0;
    padding: 0px;
`;
